import React from 'react';
import { Button } from './Button';
export interface Coach {
  id: string;
  name: string;
  role: string;
  credentials: string;
  bio: string;
  fullBio: string;
  achievements: string[];
  philosophy: string;
  image?: string;
}
interface CoachCardProps {
  coach: Coach;
  index: number;
  onViewProfile: (coach: Coach) => void;
}
export function CoachCard({
  coach,
  onViewProfile
}: CoachCardProps) {
  const initials = coach.name.split(' ').map(n => n[0]).join('');
  return <div data-component="COMP-06-CoachCard" className="bg-white rounded-2xl overflow-hidden border border-navy-100 flex flex-col cursor-pointer hover:shadow-md hover:border-navy-200 transition-all group" onClick={() => onViewProfile(coach)} role="button" tabIndex={0} onKeyDown={e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onViewProfile(coach);
    }
  }} aria-label={`View profile of ${coach.name}`} data-id="element-43">
      <div className="p-8 flex-1 flex flex-col items-center text-center" data-id="element-44">
        {coach.image ? <img src={coach.image} alt={coach.name} className="w-28 h-28 rounded-full object-cover border-2 border-navy-200 mb-5" data-id="element-45" /> : <div className="w-28 h-28 rounded-full bg-navy-100 border-2 border-navy-200 flex items-center justify-center mb-5" data-id="element-46">
            <span className="text-2xl font-display font-bold text-navy-400" data-id="element-47">
              {initials}
            </span>
          </div>}

        <h3 className="text-xl font-bold text-navy-900 mb-1 group-hover:text-brand-blue transition-colors" data-id="element-48">
          {coach.name}
        </h3>
        <p className="text-brand-blue font-medium text-sm mb-1" data-id="element-49">
          {coach.credentials}
        </p>
        <p className="text-navy-500 text-sm font-medium mb-4" data-id="element-50">{coach.role}</p>

        <p className="text-navy-600 text-sm mb-6 flex-1 leading-relaxed" data-id="element-51">
          {coach.bio}
        </p>

        <div className="w-full inline-flex items-center justify-center font-semibold rounded-md transition-colors duration-200 px-5 py-2.5 text-base bg-transparent border-2 border-brand-blue text-brand-blue group-hover:bg-brand-blue/10" aria-hidden="true" data-id="element-52">
          View Profile
        </div>
      </div>
    </div>;
}